import React from 'react';

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {hasError: false, error: null};
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return {hasError: true, error};
    }

    handleRetry = () => {
        this.setState({hasError: false, error: null});
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: '2rem',
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
                }}>
                    <h1 style={{fontSize: '1.5rem', marginBottom: '1rem', color: '#1a1a2e'}}>
                        Something went wrong
                    </h1>
                    <p style={{color: '#6b7280', marginBottom: '1.5rem', textAlign: 'center'}}>
                        An unexpected error occurred. Please try again.
                    </p>
                    <button style={{
                        padding: '0.5rem 1.5rem',
                        backgroundColor: '#EF5A2B',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '0.875rem'
                    }}
                    type="button"
                    onClick={this.handleRetry}
                    >
                        Try again
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
